<template>
  <div>
    <please-wait-modal/>
    <div class="d-sm-flex align-items-center justify-content-between mb-4">
      <h1 class="h3 mb-0 text-gray-800">{{ this.$route.query.id != null ? 'Edit' : 'Add' }} News</h1>
    </div>
    <div class="form-group">
      <div class="row px-3">
        <label for="#form-title" class="col-lg-4 pl-0 m-0 d-flex align-items-center">Title</label>
        <input type="text" class="form-control col-lg-8" id="form-title" placeholder="Title" v-model="title">
      </div>
    </div>
    <div class="form-group">
      <div class="row px-3">
        <label for="#form-title" class="col-lg-4 pl-0 m-0 d-flex">News</label>
        <div class="col-lg-8 p-0 m-0 d-flex">
          <textarea class="form-control" id="news_desc" v-html="news"></textarea>
        </div>
      </div>
    </div>
    <div class="form-group">
      <div class="row px-3">
        <label for="#form-TLahir" class="col-lg-4 pl-0 m-0 d-flex">Publish Date</label>
        <div class="col-lg-8 p-0 m-0">
          <div class="row">
            <div class="col">
              <v-date-picker v-model="publish_date"
                locale="id-ID"
                :input-props='{
                  class: "form-control w-100",
                }'
                :min-date="now_date"/>
            </div>
            <div class="col">
              <vue-timepicker
                format="HH:mm"
                v-model="publish_time"
                input-class="w-100"
                :minute-interval="interval_user_publish"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="form-group">
      <div class="row px-3">
        <label for="#form-title" class="col-lg-4 pl-0 m-0 d-flex">Photo</label>
        <div class="col-lg-8 p-0 m-0">
          <div class="row">
            <div class="col-12">
              <input type="file" id="input_photo" class="d-none" v-on:change="upload_photo" accept="image/*">
              <button class="btn btn-primary" type="button" onclick="$('#input_photo').trigger('click')">Choose Photo</button>
            </div>
            <div class="col-6 mt-3" v-if="picture != ''">
              <img :src="picture" style="height: 200px;">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="form-group text-right mt-3">
      <button type="button" class="btn btn-danger" onclick="location.href='/news'">Cancel</button>
      <button type="button" class="btn btn-primary" v-on:click="save">Save</button>
    </div>
  </div>
</template>

<script>
import please_wait_modal from '@/layout/please_wait_modal'

import 'summernote/dist/summernote.css'
import summernote from 'summernote'

import DatePicker from 'v-calendar/lib/components/date-picker.umd'

import VueTimepicker from 'vue2-timepicker'
import 'vue2-timepicker/dist/VueTimepicker.css'

export default {
  components:{
    'v-date-picker': DatePicker,
    'please-wait-modal': please_wait_modal,
    VueTimepicker,
  },
  async mounted(){
    var context = this
    $('#news_desc').summernote({
      height: '250',
      width: '100%',
      callbacks: {
        onChange: function(contents, $editable) {
          context.news = contents
        }
      },
      popover: {
        image: [],
        link: [],
        air: []
      },
      toolbar: [
        ['style', ['bold', 'italic', 'underline', 'clear']],
        ['font', ['strikethrough', 'superscript', 'subscript']],
        ['fontsize', ['fontsize']],
        ['color', ['color']],
        ['para', ['ul', 'ol', 'paragraph']],
      ]
    })

    // await this.get_setting()
    if(this.$route.query.id != null){
      await this.get_data()
    }
  },
  data(){
    return{
      title: '',
      news: '',
      publish_date: '',
      publish_time: '',
      picture: '',
      data_photo: '',
      interval_user_publish: 1,
      now_date: new Date(),
    }
  },
  methods:{
    async save(){
      try{
        if(this.title == '')
          this.$toasted.show('Title is empty')
        else if(this.news == '')
          this.$toasted.show('News is empty')
        else if(this.publish_date == '')
          this.$toasted.show('Publish Date is empty')
        else if(this.publish_time == '')
          this.$toasted.show('Publish Time is empty')
        else{
          $('#please_wait_modal').modal('show')
          var data = {}
          if(this.data_photo != '')
            data.image = await image2base64(this.picture)
          data.title = this.title
          data.news = this.news
          var date = moment(this.publish_date).format('YYYY-MM-DD')
          data.publish_date = moment(date+' '+this.publish_time).format('YYYY-MM-DD HH:mm:ss')
          if(this.$route.query.id != null)
            data.id = this.$route.query.id

          var response
          if(this.$route.query.id == null)
            response = await axios.post(base_url+'/news',data)
          else
            response = await axios.put(base_url+'/news',data)

          $('#please_wait_modal').modal('hide')
          var response_data = response.data
          if(response_data.status == "success"){
            location.href = '/news'
          }
          else
            this.$toasted.show(response_data.message)
        }
      } catch(e) {
        $('#please_wait_modal').modal('hide')
        this.$toasted.show(e.message)
      }
    },
    async get_data(){
      try{
        var response = await axios.get(base_url+'/news?id='+this.$route.query.id)

        var response_data = response.data
        if(response_data.status == "success"){
          this.title = response_data.data.title
          this.news = response_data.data.news
          this.publish_date = new Date(moment(response_data.data.publish_date).format('MMMM DD, YYYY HH:mm:ss'))
          this.publish_time = moment(response_data.data.publish_date).format('HH:mm')
          this.picture = response_data.data.file_name != null ? base_url+'/images/news?file_name='+response_data.data.file_name : ''
          if(response_data.data.helper_sub_category != null){
            this.helper_category = response_data.data.helper_sub_category.helper_category.id
            this.type = 'specific'
          }
          $('#news_desc').summernote('code', this.news)

          if(response_data.data.helper_sub_category != null){
            await this.get_helper_sub_category()
            this.helper_sub_category = response_data.data.helper_sub_category_id
          }
          // console.log(moment(response_data.data.publish_date).format('DD/MM/YYYY'))
        }
      } catch(e) {
        this.$toasted.show(e.message)
      }
    },
    async get_setting(){
      try{
        var response = await axios.get(base_url+'/setting')

        var response_data = response.data
        if(response_data.status == "success"){
          this.interval_user_publish = response_data.data.interval_user_publish
          // console.log(moment(response_data.data.publish_date).format('DD/MM/YYYY'))
        }
      } catch(e) {
        this.$toasted.show(e.message)
      }
    },
    upload_photo(event){
      this.picture = URL.createObjectURL(event.target.files[0])
			this.data_photo = event.target.files[0]
    },
  }
}
</script>
